import { Moment } from "moment";

export default interface Fatura {
  id: string;
  descricao: string;
  periodoInicio: Moment;
  periodoFim: Moment;
  pdf: string;
  situacao: SituacaoFatura;
  total: Number;
  pagoEm: Moment | undefined;
  criadoEm: Moment;
}

export enum SituacaoFatura {
  DRAFT = "draft",
  OPEN = "open",
  PAID = "paid",
  VOID = "void",
  UNCOLLECTIBLE = "uncollectible",
}
